/* tslint:disable */
/* eslint-disable */
/**
 * Xpanse Portal BFF Service API
 * Rest API for Xpanse Portal
 *
 * The version of the OpenAPI document: @project.version@
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WhiteLabelingSettings,
} from '../models/index';
import {
    WhiteLabelingSettingsFromJSON,
    WhiteLabelingSettingsToJSON,
} from '../models/index';

/**
 * 
 */
export class WhiteLabelingApi extends runtime.BaseAPI {

    /**
     * Get WhiteLabeling Settings
     */
    async getSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WhiteLabelingSettings>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/whitelabeling/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WhiteLabelingSettingsFromJSON));
    }

    /**
     * Get WhiteLabeling Settings
     */
    async getSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WhiteLabelingSettings>> {
        const response = await this.getSettingsRaw(initOverrides);
        return await response.value();
    }

}
